import "./Contact.module.css";
import KurumsalKimlikBasligi from "@/reusable_sections/Header";
import BizeUlasin from "./sections/BizeUlasin";
import OfisLokasyonuVeRandevu from "./sections/OfisLokasyonuVeRandevu";
import KurumsalAltBilgi from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <KurumsalKimlikBasligi />
      <BizeUlasin />
      <OfisLokasyonuVeRandevu />
      <KurumsalAltBilgi />
    </div>;
}